import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Route, Switch } from 'react-router';
import { connect } from 'react-redux';

import i18n from 'util/i18n';

import { ErrorList } from 'components/ErrorList';
import SectionNavigation from 'components/Section/shared/SectionNavigation';
import { rootSelectors } from '@redux/modules/selectors';
import Intro from './Intro';
import ConnectedMarital from './RelationshipStatus/Marital';
import ConnectedCohabitants from './RelationshipStatus/Cohabitants';
import People from './People';
import Relatives from './Relatives';
import Review from './Review';
import SectionNotFound from '../shared/SectionNotFound';

const Relationships = function (props) {
  const { subsection, location, isReview } = props;

  const subsectionClasses = classnames('view', `view-${subsection.name}`);

  const title = isReview && i18n.t('review.title');
  const para = isReview && i18n.m('review.para');

  return (
    <div>
      <div className="section-view">
        {title && <h1 className="title">{title}</h1>}
        {para}

        <div className={subsectionClasses}>
          {isReview && (
            <div className="top-btns">
              <ErrorList />
            </div>
          )}

          <Switch>
            <Route path="/form/relationships/intro" component={Intro} />
            <Route path="/form/relationships/status/marital" component={ConnectedMarital} />
            <Route path="/form/relationships/status/cohabitant" component={ConnectedCohabitants} />
            <Route path="/form/relationships/people" component={People} />
            <Route path="/form/relationships/relatives" component={Relatives} />
            <Route path="/form/relationships/review" component={Review} />
            <Route component={SectionNotFound} />
          </Switch>
          <SectionNavigation currentPath={location.pathname} />
        </div>
      </div>
    </div>
  );
};

/**
 * @param {import('types/state').RootState} state
 */
const mapStateToProps = (state) => ({
  subsection: state.section.subsection,
  isReview: rootSelectors.section.getIsSectionInReview(state),
  formType: rootSelectors.application.getFormType(state),
});

Relationships.propTypes = {
  subsection: PropTypes.object,
  location: PropTypes.object,
  formType: PropTypes.string,
  isReview: PropTypes.bool,
};

Relationships.defaultProps = {
  subsection: {},
  location: {},
};

export var RelationshipSections = function () {
  return <Review forPrint />;
};

export default connect(mapStateToProps)(Relationships);
